import { Upload } from 'antd';
import styled from 'styled-components';

export const TAUpload_ = styled(Upload)`
	.ant-upload.ant-upload-select-picture-card {
		background-color: transparent;

		&:hover {
			}
		}
	}
`;

export const TAUploadText = styled.div``;
